module.exports = "leftie {\n  border-radius: 8px 8px 0px 0px; }\n"